import { render, staticRenderFns } from "./importOrders.vue?vue&type=template&id=2f8defd4&scoped=true"
import script from "./importOrders.vue?vue&type=script&lang=js"
export * from "./importOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8defd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f8defd4')) {
      api.createRecord('2f8defd4', component.options)
    } else {
      api.reload('2f8defd4', component.options)
    }
    module.hot.accept("./importOrders.vue?vue&type=template&id=2f8defd4&scoped=true", function () {
      api.rerender('2f8defd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/importOrders.vue"
export default component.exports